/**
 * Page/view manager, handles some common elements and helper functions
 * todo: come up with a way to pass data to any page during init
 */

// global var used in the Selenium test script
var loaded = false;

app.page = (function() {
    "use strict";
    var data = {},
        title = 'Young Living',
        titleSeparator = ' | ',
        titleOrig = window.document.title,
        storageName = 'myyl-history',
        history = [],
        self = {

        /**
         * Load the json data file for a page
         * page is the app.page.pagename object
         */
        load: function(endpoint, page, errorCallback) {
            // check if data was previously loaded and use cached data if so
            var id = endpoint.replace(/\.[^/.]+$/, '');
            if (data[id]) {
                // data has been previously cached
                self.postLoad(data[id], page);

            } else {
                // load data from the server
                $.getJSON('/'+ endpoint + cb,
                    function(result) {
                        // cache data
                        data[id] = result;
                        self.postLoad(data[id], page);
                    }
                ).fail(function() {
                    if (typeof errorCallback == 'function') {
                        errorCallback();
                    }
                });
            }
        },

        /**
         * Common tasks once a page has loaded
         */
        postLoad: function(data, page) {
            self.setID(data.page);
            self.setTitle(data.title);

            var finishLoad = function () {
                self.addClickHandler('[data-page]');
                self.initHelpTips();
                // app.main.hideLoader();
                window.scrollTo(0, 0);
            };

            // EWM needs to make API calls on each page load
            if (page.loadsAsyncronously) {
                page.render(data, function () {
                    finishLoad();
                });
            } else {
                page.render(data);
                finishLoad();
            }
        },

        /**
         * Load the selected page
         * Essentially just changes the window hash
         * name: the page module name
         * replace: replace the current page in browsing history
         */
        loadPage: function(name, replace) {
            if (replace) {
                window.location.replace('#'+ name);
                return;
            }

            window.location.hash = name;

            if (!name) {
                window.history.pushState('', document.title, window.location.pathname);
            }
        },

        /**
         * Any element with a data-page attribute will load that page when clicked
         * todo: the off('click') function is too harsh, causes the menu to not close in some instances
         */
        addClickHandler: function(selector) {
            $(selector).on('click', function(e) {
                e.preventDefault();
                if ($(this).hasClass('is-disabled') == false) {
                    self.loadPage($(this).data('page'));
                }
            });
        },

        /**
         * Sets the id attribute of the body tag. Useful for CSS.
         */
        setID: function(val) {
            if (val === undefined || val == '' || val === '/') {
                // val = 'index';
                return;
            }
            $('body').attr('id', 'page-'+ val);
        },

        /**
         * Update the page title
         */
        setTitle: function(val) {
            //window.document.title = title;
            window.document.title = titleOrig;

            if (Array.isArray(val)) {
                for (var i=0; i<val.length; i++) {
                    window.document.title += (titleSeparator + val[i]);
                }
            } else {
                window.document.title += (val ? titleSeparator + val : '');
            }
        },

        /**
         * Clears cached data
         */
        clearData: function() {
            data = {};
        },

        /**
         * Initializes and help tips that may be on the page
         * @function initHelpTips
         */
        initHelpTips: function() {
            $('.help-tip, .help-tip-text').on('click', function() {
                self.openTip($(this));
            });

            $('.help-tip-text').on('mouseover', function() {
                self.openTip($(this));
            });

            // special tip for signed-in message
            $('.alert-tip').on('click', function() {
                var pos = $(this).position(),
                    $popup = $('#signed-in-popup'),
                    top = pos.top - $popup.height() - 40,
                    left = pos.left - $popup.width() + 90;

                if (window.innerWidth <= 550) {
                    left = -15;
                }

                $popup.css({
                    top: top,
                    left: left
                }).addClass('is-active');

                $(document).on('mousedown touchstart', self.closeAlert);
                $(window).on('resize scroll', self.closeAlert);
            });
        },

        /**
         * Reveal the help tip popup
         */
        openTip: function($elt) {
            var pos = $elt.position(),
                offset = $elt.offset(),
                $popup = $('#help-popup');

            $popup.removeClass('inline');
            $('span', $popup).html(app.main.lang($elt.data('key')));

            var top = offset.top - $popup.height() - 40,
                left = offset.left - $popup.width() + 220;

            $popup.css({
                top: top,
                left: left
            }).addClass('is-active');

            $(document).on('mousedown touchstart', self.closeTip);
            $(window).on('resize', self.closeTip);
            $elt.on('mouseout', function() {
                window.setTimeout(self.closeTip, 1000);
            });
        },

        /**
         * Hide the help tip popup
         * @function closeTip
         */
        closeTip: function() {
            $('#help-popup').removeClass('is-active');
            $(document).off('mousedown touchstart', self.closeTip);
            $(window).off('resize', self.closeTip);
        },

        closeAlert: function(e) {
            if ($(e.target).hasClass('sign-out')) {
                return;
            }
            $('#signed-in-popup').removeClass('is-active');
            $(document).off('mousedown touchstart', self.closeAlert);
            $(window).off('resize scroll', self.closeAlert);
        },

        /**
         * Fire off any alerts that need to appear on any/all pages
         */
        initGlobalAlerts: function() {
            var alertLangKeys = ['public_sale_alert'];

            alertLangKeys.forEach(function(alertKey) {
                app.message.alert({
                    id: alertKey +'_monday',
                    setCookie: true,
                    message: app.main.lang(alertKey),
                    scroll: true
                });
            });
        },

        /**
         * Show page loading animation
         */
        showLoader: function() {
            loaded = false;
            $('#loader').addClass('is-active');
        },

        /**
         * Hide page loading animation
         */
        hideLoader: function() {
            loaded = true;
            $('#loader').removeClass('is-active');
        },

        /**
         * Check if localStorage history exists
         */
        initHistory: function() {
            var storageObj = localStorage.getItem(storageName);

            if (storageObj) {
                // localStorage is a string, convert to array
                history = storageObj.split(',');
            }
        },

        /**
         * Track page history
         */
        addHistory: function() {
            self.initHistory();

            // ignore #support
            if (window.location.href.indexOf('#support') > -1) {
                return;
            }

            if (history.length > 7) {
                // only store last 8 pages
                history.shift();
            }

            history.push(window.location.href);
            localStorage.setItem(storageName, history);
        },

        /**
         * Get history items
         */
        getHistory: function(index) {
            self.initHistory();

            if (history.length < 1) {
                return [];
            }

            // return full history
            if (!index) {
                return history;
            }

            // handle negative index
            if (index < 0) {
                index = history.length + index;
            }

            // can't go beyond history length
            if (index > history.length) {
                index = history.length;
            }

            if (history[index]) {
                return history[index];

            } else {
                return [];
            }
        },

        /**
         * Test for a touch event
         */
        checkTouchEnabled: function() {
            window.addEventListener('touchstart', function setHasTouch () {
                touchEnabled = true;
                console.log('Touch is enabled');
                window.removeEventListener('touchstart', setHasTouch);
            }, false);
        }
    };
    return self;
}());